import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {EditComponent} from '../../../core/components/edit-component';
import {ApiResponse} from 'common-shared';
import {UnitModel} from '../models/unit.model';
import {ClassificatorValueQuery} from 'common-shared';
import {ClassificatorValuesQuery} from 'common-shared';
import {NgForm} from "@angular/forms";

@Component({
  selector: 'mes-web-unit-edit',
  templateUrl: './unit-edit.component.html'
})
export class UnitEditComponent extends EditComponent implements OnInit {
  @Input() response: ApiResponse<any>;
  @Input() unit: UnitModel;
  physicalDimensions: ClassificatorValueQuery[];
  @Output() changed = new EventEmitter<boolean>();
  @ViewChild(NgForm, {static: true}) form: NgForm;

  constructor(public classificatorValueService: ClassificatorValuesQuery) {
    super();
  }

  ngOnInit() {
    this.classificatorValueService.physicalDimensions$.subscribe(value => {
      return this.physicalDimensions = value;
    });

    this.form.statusChanges.subscribe(value => {
      this.changed.emit(this.form.pristine);
    });
  }

  getPow(roundingFactor: number) {
    return Math.pow(10, -1 * roundingFactor);
  }
}
